/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ArchivedPersonResource } from '../models/ArchivedPersonResource';
import type { ArchivePeopleRequest } from '../models/ArchivePeopleRequest';
import type { DeleteArchivedPeopleRequest } from '../models/DeleteArchivedPeopleRequest';
import type { PersonSearchResource } from '../models/PersonSearchResource';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class PeopleArchiveService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Get archived people
     * @returns any OK
     * @throws ApiError
     */
    public getArchivedPeople(): CancelablePromise<{
        data: PersonSearchResource;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/people/archive',
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Archive people
     * @returns any OK
     * @throws ApiError
     */
    public archivePersonCreate({
        requestBody,
    }: {
        /**
         * Email payload
         */
        requestBody: ArchivePeopleRequest,
    }): CancelablePromise<{
        data: ArchivedPersonResource;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/people/archive',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

    /**
     * Delete archived people permanently
     * @returns any OK
     * @throws ApiError
     */
    public unarchivePeople({
        requestBody,
    }: {
        /**
         * Filters to find people to delete
         */
        requestBody: DeleteArchivedPeopleRequest,
    }): CancelablePromise<{
        data: ArchivedPersonResource;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/people/unarchive',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
            },
        });
    }

}
